import { Box, List, Button, Typography } from "@material-ui/core";
import React from "react";
import { useHistory } from "react-router-dom";
import usePathStyles from "./Report/src/Component/Share/usePathStyles";
import DrawerComponent from "./Dashboard/Dashboard-Component/DrawerComponent";
import useTiers from "../../hooks/useTiers";
let menuList = [
  ["Total Earn Points", "loyalty/total", false],
  ["Total Redeem Points", "loyalty/redeem", false],
  ["Total Remaining Points", "loyalty/remaining", false],
  ["Tiers Report", "loyalty/tiers", false],
];
export default function LoyaltyPath() {
  const classes = usePathStyles();
  const history = useHistory();
  const { tiers, loading, error } = useTiers();
  if (!loading && !error && menuList.length < 5) {
    menuList = menuList.concat(
      tiers.map((tier) => [
        tier.name + " Report",
        "each-loyalty/" + tier.name,
        false,
      ])
    );
  }
  return (
    <Box className={classes.container}>
      <DrawerComponent onReport />
      <Typography className={classes.title} variant="h2" align="center">
        Loyalty
      </Typography>
      <List>
        {menuList.map((text) => (
          <Box>
            <Button
              disabled={text[2]}
              variant={"outlined"}
              className={classes.button}
              onClick={() => {
                history.push({
                  pathname: "/bi/report/" + text[1],
                });
              }}
            >
              {text[0]}
            </Button>
          </Box>
        ))}
      </List>
    </Box>
  );
}
